import { isEmpty } from 'lodash-es';
import React from 'react';

import { IParameterInfo, IParameterOption } from '~/src/dash/components/forms/formBuilder/common';
import { useFormBuilderStore } from '~/src/dash/components/forms/formBuilder/contexts';
import { ParameterSelect } from '~/src/dash/components/forms/formBuilder/ParameterRow/ParameterSelect';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { borderRadius, Col, Cols, Div, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const findParameterOptionByKey = (key: string, options: Record<string, any>[]) => {
  return options.find((option) => option.key === key);
};

interface IProps {
  index: number;
  param: IParameterInfo;
  errors?: string[];
}

export const ParameterRow = ({ param, index, errors }: IProps) => {
  const { options, handleSelectParameter, handleRemoveParameter, activeParamKeys } =
    useFormBuilderStore();

  return (
    <Rows>
      {!isEmpty(errors) &&
        errors?.map((error) => (
          <Row style={{ padding: `0 ${spacing.small}` }}>
            <Text small color={publicaColors.red}>
              {`• ${error}`}
            </Text>
          </Row>
        ))}
      <Row noPadding>
        <Cols
          smallPadding
          gap={spacing.small}
          style={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            border: `1px solid ${publicaColors.lightGray}`,
            borderRadius: borderRadius.small,
            backgroundColor: publicaColors.veryLightBlue,
          }}
        >
          <Col flex>
            <Cols gap={spacing.base} style={{ alignItems: 'flex-start' }}>
              <Col>
                <ParameterSelect
                  options={options}
                  handleSelectParameter={handleSelectParameter}
                  index={index}
                  activeKeys={activeParamKeys}
                  selected={findParameterOptionByKey(param.key, options) as IParameterOption}
                  key={param.label}
                />
              </Col>
              {param.label && (
                <Col flex>
                  {param.Component ? (
                    <param.Component {...param.props} />
                  ) : (
                    <Text
                      small
                      muted
                      italic
                      style={{ paddingTop: spacing.extraSmall, paddingLeft: spacing.base }}
                    >
                      Parameter is currently disabled.
                    </Text>
                  )}
                </Col>
              )}
            </Cols>
          </Col>
          <Col style={{ padding: '8px 16px' }}>
            <Div
              onClick={() => handleRemoveParameter(index)}
              displayFlex
              style={{ cursor: 'pointer' }}
            >
              <IconV2 name='close' color={publicaColors.veryDarkGray} />
            </Div>
          </Col>
        </Cols>
      </Row>
    </Rows>
  );
};
